import React from 'react';
import {useSelector} from 'react-redux'
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography, Divider } from '@material-ui/core';
import ENUMS from '../../../../../../configs/enums';
import t from '../../../../../../configs/translations'
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const authDataXX = useSelector(state => state.authData);

  const user = {
    avatar: '/images/avatars/anonym.png'
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user.avatar}
        to="/settings"
      />
      <Typography
        className={classes.name}
        variant="h4"
      >
        {authDataXX.username}
      </Typography>
      <Typography variant="body2">{t[ENUMS.roleNames[authDataXX.subTypeId]]}</Typography>
      <Divider />
      <Divider />
      {/*<Typography variant="body1">*/}
      {/*  Balance: {authDataXX.wallets ? authDataXX.wallets[0].balance + authDataXX.wallets[0].currency : ''}*/}
      {/*</Typography>*/}
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
